import { Property } from '@propertypal/shared/src/types/property';
import { PropertySearchResult } from '@propertypal/shared/src/types/propertySearch';
import React, { CSSProperties, FunctionComponent, ReactNode } from 'react';
import PropertyBox from '../property-box/PropertyBox';
import GridContainer, { FooterContainer, LowerAdContainer, UpperAdContainer } from './PropertyGrid.style';
import PropertyPlaceholder from './PropertyPlaceholder';

interface Props {
  containerStyle?: CSSProperties;
  ariaLabel?: string;
  properties?: Property[] | null;
  onFavourite?: () => (favourited: boolean, propertyId: number) => Promise<boolean>;
  onHideToggle?: () => (hidden: boolean, propertyId: number) => Promise<boolean>;
  onEmailClick?: (property: Property) => void;
  onCallClick?: (property: Property) => void;
  onPropertyClick?: (property: Property) => void;
  locationDetail?: PropertySearchResult['locationDetail'];
  maxColumns?: number;
  hideFooter?: boolean;
  imageLocator?: string;
  popularProperties?: boolean; // on homepage, when laptopLargeMax breakpoint, hides 4th property
  upperMiddleAd?: ReactNode;
  lowerMiddleAd?: ReactNode;
  footer?: ReactNode;
  eagerLoading?: boolean;
  photoScroller?: boolean;
  handPicked?: boolean;
}

const PropertyGrid: FunctionComponent<Props> = (props) => {
  const hasResults = !!props.properties?.length;

  if (!props.properties) {
    return (
      <GridContainer
        style={props.containerStyle}
        maxColumns={props.maxColumns || 3}
        popularProperties={props.popularProperties}
        handPicked={props.handPicked}
      >
        <PropertyPlaceholder />
        <PropertyPlaceholder />
        <PropertyPlaceholder />
        <PropertyPlaceholder />
        <PropertyPlaceholder />
        <PropertyPlaceholder />
        <PropertyPlaceholder />
        <PropertyPlaceholder />
        <PropertyPlaceholder />
        <PropertyPlaceholder />
        <PropertyPlaceholder />
        <PropertyPlaceholder />
      </GridContainer>
    );
  }

  return (
    <GridContainer
      aria-label={props.ariaLabel}
      style={props.containerStyle}
      maxColumns={props.maxColumns || 3}
      popularProperties={props.popularProperties}
      handPicked={props.handPicked}
    >
      {props.properties.map((property, index) => {
        return (
          <PropertyBox
            key={`${property.id}${property.featuredListing}${property.type}`}
            property={property}
            onFavourite={props.onFavourite}
            onHideToggle={props.onHideToggle}
            onEmailClick={props.onEmailClick}
            onCallClick={props.onCallClick}
            imageLocator={props.imageLocator}
            locationDetail={props.locationDetail}
            loading={props.eagerLoading && index < 4 ? 'eager' : 'lazy'}
            useSlider={props.photoScroller}
            hideFooter={props.hideFooter}
            onClick={() => {
              if (props.onPropertyClick) props.onPropertyClick(property);
            }}
          />
        );
      })}

      {hasResults && props.upperMiddleAd && <UpperAdContainer>{props.upperMiddleAd}</UpperAdContainer>}

      {hasResults && props.lowerMiddleAd && <LowerAdContainer>{props.lowerMiddleAd}</LowerAdContainer>}

      {hasResults && props.footer && <FooterContainer>{props.footer}</FooterContainer>}
    </GridContainer>
  );
};

export default PropertyGrid;
